export default __webpack_public_path__ + "static/media/bm.cfda8150.jpg";